module.exports = __webpack_public_path__ + "img/CALIDAD.bf4473dd.svg";